import { ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';
import { SOFTWARE_PRODUCT } from './common/index.tsx';

export const routeGroupsProjectSettingsSoftwareRedirectRoute: InvariantRoute = {
	// the following route should be non-exact, it will handle "index" and "404" cases
	name: `${ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE}-redirect`,
	path: `/jira/${SOFTWARE_PRODUCT}/projects/:projectKey/settings`,
};
